import React from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import "react-table/react-table.css";
import 'bootstrap/dist/css/bootstrap.css';
import ReactTooltip from "react-tooltip";
import NPReactTable from '../../NPReactTable';
import Dialog from 'react-bootstrap-dialog';
import { hasGrant } from '../../util/grantHelper';
import * as Grants from '../../util/grants';
import FontAwesome from 'react-fontawesome';
import * as Convert from '../../util/unitConversion';

const numberCell = row => row.value?.toLocaleString('sv', { useGrouping: true }) || '0';

const WEEK_COLUMNS = [
  {
    Header: 'Week',
    accessor: 'Week',
    maxWidth: 84
  },
  {
    Header: 'Capacity',
    accessor: 'Capacity',
    maxWidth: 100,
    Cell: numberCell
  },
  {
    Header: 'Ordered\nvolume',
    accessor: 'Ordered',
    maxWidth: 100,
    Cell: numberCell
  },
];

const MONTH_COLUMNS = [
  {
    Header: 'Month',
    accessor: 'Month',
    maxWidth: 60
  },
  {
    expander: true,
    width: 35
  },
  {
    Header: 'Capacity',
    accessor: 'Capacity',
    maxWidth: 100,
    Cell: numberCell
  },
  {
    Header: 'Ordered\nvolume',
    accessor: 'Ordered',
    maxWidth: 100,
    headerStyle: { 
        whiteSpace: 'pre-line',
    },
    Cell: numberCell
  },
];

class CustomerExternal extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      isLoading: false,
    };
  }

  render()
  {
    const { data } = this.props;

    if (this.state.isLoading){
      return <LoadingSpinner isLoading={true} />
    }

    if (!data){
      return null;
    }
    const infoExternal = `
      <div>
        <strong>Data Columns:</strong><br/>
        <div style="padding-left: 20px;">
            • <strong>Capacity:</strong> External converter machine capacity<br/>
            • <strong>Ordered volume:</strong> Sum of orders that are converted by the external converter. <br/>
        </div><br/>

        Expand each month (▶) to see weekly breakdown<br/>

        Note: Machine filter has no effect on this data. This is a summary of all orders for the external converter.
      </div>
    `;
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <legend className="allocationLegend" style={{ display: 'inline-block', width: 'auto', paddingBottom: 0 }}>
            {data.ShortName} {data.Pm} external capacity
          </legend>
          <FontAwesome 
            name="info-circle" 
            data-for="globalTip" 
            data-tip={infoExternal}
            style={{ cursor: 'pointer', fontSize: '16px' }}
          />
        </div>
        <Dialog ref={(el) => { this.dialog = el }} />
        <ReactTooltip id="globalTip" html place="bottom" effect="solid"/>
        <legend className="allocationLegend" style={{ paddingBottom: 0 }}>
          {data.Description}
        </legend>
        <div style={{ width: 'fit-content' }}>
          <NPReactTable
            data={data.Months || []}
            columns={MONTH_COLUMNS}
            showPagination={false}
            showPageSizeOptions={false}
            hasHeaderGroups={false}
            sortable={false}
            minRows={1}
            defaultPageSize={10000}
            className="np-react-table allocationTable"
            SubComponent={row => (
              <div style={{ padding: '10px' }}>
                <NPReactTable
                  data={row.original.Weeks || []}
                  columns={WEEK_COLUMNS}
                  showPagination={false}
                  defaultPageSize={10000}
                  minRows={1}
                  className="np-react-table weekAllocationTable"
                  hasHeaderGroups={false}
                />
              </div>
            )}
          />
        </div>
      </div>
    );
  }
}
export default CustomerExternal;